<template>
    <section>
        <b-btn type="primary" @click="open=true">{{$t('message.add_homebase')}}</b-btn>
        <b-modal v-model="open" :title="$t('message.add_homebase')" ref="modal" id="modal-homebase">
            <vue-form-generator ref="createHomebase" :schema="schema" :model="model" :options="formOptions" @validated="onValidated"></vue-form-generator>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.cancel')}}</b-btn>
                <b-btn @click="validate" type="primary">{{$t('message.create')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import storage, {HOMEBASE_REQUEST, BUILDING_REQUEST} from '../../../_store'
    import mixins from '../../../modules/mixins'

    export default {
        name: 'create-homebase',
        mixins: [mixins],
        data () {
            return {
                open: false,
                isValid: false,
                model: {
                    building: null,
                    name: null,
                    serialNumber: null
                },
                schema: {
                    fields: [{
                        type: 'typeaheadSelect',
                        label: this.$t('message.building'),
                        i18n: {
                            label: 'message.building',
                            newItem: 'message.new_building'
                        },
                        values: [],
                        required: true,
                        model: 'building'

                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.name'),
                        i18n: {
                            label: 'message.name'
                        },
                        model: 'name',
                        featured: true,
                        required: true,
                        validator: VueFormGenerator.validators.string
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.serial_number'),
                        i18n: {
                            label: 'message.serial_number'
                        },
                        model: 'serialNumber',
                        required: true,
                        validator: VueFormGenerator.validators.string
                    }]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                }
            }
        },
        watch: {
            open (value) {
                if (value) {
                    this.reloadBuildings()
                }
            }
        },
        methods: {
            onValidated  (isValid) {
                this.isValid = isValid
            },
            validate () {
                this.$refs.createHomebase.validate()
                if (this.isValid) {
                    storage.dispatch(HOMEBASE_REQUEST, this.model)
                        .then(response => {
                            this.open = false
                            this.notify('info', response.data.message)
                        }).catch(err => {
                            this.notify('danger', err.response.data.message)
                        })
                }
            },
            reloadBuildings () {
                storage.dispatch(BUILDING_REQUEST).then((response) => {
                    this.schema.fields[0].values = response.data.data
                    const thiz = this
                    setTimeout(function() {
                        thiz.model.building = thiz.schema.fields[0].values > 0 ? thiz.schema.fields[0].values[0].id : null
                    }, 100)

                })
            }
        }
    }
</script>

<style scoped>

</style>
